import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { AdvancedMaterialTable } from 'material-ui-advanced-table';
import React from 'react';

const useStyles = makeStyles({
  table: {
    width: '100%',
  },
});

const tableIcons = {
  Add: AddBox,
  Check,
  Clear,
  Delete: DeleteOutline,
  DetailPanel: ChevronRight,
  Edit,
  Export: SaveAlt,
  Filter: FilterList,
  FirstPage,
  LastPage,
  NextPage: ChevronRight,
  PreviousPage: ChevronLeft,
  ResetSearch: Clear,
  Search,
  SortArrow: ArrowUpward,
  ThirdStateCheck: Remove,
  ViewColumn
};

export default function DataTable(params: {
  title: string,
  columns: Array<{ title: string, field: string }>,
  data: any,
  className?: string,
  onRowClick?: (event?: React.MouseEvent, rowData?: any) => void,
  options?: {
    exportButton?: boolean,
    exportAllData?: boolean
  }
  editable?: any,
}) {
  const classes = useStyles();

  const Container = (props: any) => {
    return React.createElement(Paper, Object.assign({
      elevation: 2
    }, {...props, className: classes.table}));
  };

  return (
    <AdvancedMaterialTable
      options={params.options}
      className={classes.table}
      columns={params.columns}
      components={{
        Container,
      }}
      data={params.data}
      title={params.title}
      onRowClick={params.onRowClick}
      editable={params.editable}
      /*
      //@ts-ignore */
      icons={tableIcons}
    />
  );
}